module.exports = __webpack_public_path__ + "DSC05475.8d11aba224fc747d89da.jpg";